<snelstart-ui-button (click)="this.showDialog()"
                     [disabled]="((corporateTaxEntity$ | async)?.aangifte?.balansEnResultatenrekening?.machinesEnInstallaties?.at(0)?.slotbalans ?? null) === null"                     class="custom-input-150"
                     icon="plus"
                     type="secondary">Specificeer
</snelstart-ui-button>

<snelstart-ui-dialog-definition [(visible)]="dialogVisible" id="tm" size="xl"
                                title="Specificatie machines en installaties">
    <snelstart-ui-dialog-header-content>
        Vermeld de waardes per {{ ((corporateTaxEntity$ | async)?.aangifte?.boekjaar?.einddatum | date:'d MMMM yyyy':'':'nl-NL')}}.
    </snelstart-ui-dialog-header-content>

    <snelstart-ui-dialog-body>
        <div style="max-width: 90%">
            <form [formGroup]="machinesEnInstallatiesFg">

                <div class="row pt-3">
                    <div class="col col-1">
                        <p>Kostprijs van de machines en installaties</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control (change)="saveForm()"
                                                          [showAllDecimals]="false"
                                                          align="right"
                                                          class="custom-input-150"
                                                          formControlName="nominaleWaardeOfKostenprijs"
                                                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                    </div>
                </div>

                <div class="row">
                    <div class="col col-1">
                        <p>Restwaarde van de machines en installaties</p>
                    </div>
                    <div class="col-2">
                        <snelstart-ui-number-form-control (change)="saveForm()"
                                                          [showAllDecimals]="false"
                                                          align="right"
                                                          class="custom-input-150" formControlName="restwaarde"
                                                          prefix="€"
                        >
                        </snelstart-ui-number-form-control>
                    </div>
                </div>
            </form>
        </div>
    </snelstart-ui-dialog-body>
    <snelstart-ui-dialog-buttons class="d-flex">
        <snelstart-ui-button btn-x class="me-1" id="cancel" type="secondary">Annuleren</snelstart-ui-button>
        <snelstart-ui-button [disabled]="!this.machinesEnInstallatiesFg.valid" icon="check" id="noSave" type="primary">
            Opslaan
        </snelstart-ui-button>
    </snelstart-ui-dialog-buttons>
</snelstart-ui-dialog-definition>
